import React from "react";
import { Box } from "@mui/material";
import Marquee from "react-fast-marquee";
import { useHistory } from "react-router-dom";

const Ticker = ({
  featuredNews,
  notifications,
  winnerNotifications,
  handleRedirect,
}) => {
  const history = useHistory();

  if (
    (!featuredNews || featuredNews.length === 0) &&
    (!notifications || notifications.length === 0)
  ) {
    return null;
  }

  return (
    <Box className="ticker-bar-wrapper">
      <Box className="ticker-live-badge">
        <Box className="ticker-live-dot" />
        <Box component="span" className="ticker-live-text">LIVE</Box>
        <Box className="ticker-separator" />
      </Box>
      <Marquee pauseOnHover gradient={false} speed={40}>
        {featuredNews?.map((news, index) => (
          <Box
            key={news.id}
            className="ticker-item"
            sx={{ display: "inline-flex", alignItems: "center" }}
          >
            <Box component="span" className="ticker-id">
              NEWS
            </Box>
            <Box
              component="a"
              href={`/news/${news.id}`}
              className="ticker-text"
              sx={{ textDecoration: "none" }}
            >
              {news.title}
            </Box>
            <Box
              component="span"
              className={`ticker-dot ${index % 2 === 0 ? "blue" : "red"}`}
            />
          </Box>
        ))}
        {notifications?.slice(0, 3).map((item, index) => (
          <Box
            key={item.id}
            onClick={() => handleRedirect(item)}
            className="ticker-item"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <Box component="span" className="ticker-id">
              ID-{item.genId}
            </Box>
            <Box component="span" className="ticker-text">
              {item.title}
            </Box>
            <Box
              component="span"
              className={`ticker-dot ${index % 2 === 0 ? "red" : "blue"}`}
            />
          </Box>
        ))}
        {winnerNotifications?.slice(0, 3).map((item, index) => (
          <Box
            key={item.id}
            onClick={() => history.push("/lottery-result")}
            className="ticker-item"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <Box component="span" className="ticker-id">
              ID-{item.genId}
            </Box>
            <Box component="span" className="ticker-text">
              {item.title}
            </Box>
            <Box
              component="span"
              className={`ticker-dot ${index % 2 === 0 ? "blue" : "red"}`}
            />
          </Box>
        ))}
      </Marquee>
    </Box>
  );
};

export default Ticker;
